module.exports = __webpack_public_path__ + "img/type-canada.e0f62c04.png";